import { render, staticRenderFns } from "./CaseRate.vue?vue&type=template&id=517a1927&scoped=true"
import script from "./CaseRate.vue?vue&type=script&lang=js"
export * from "./CaseRate.vue?vue&type=script&lang=js"
import style0 from "./CaseRate.vue?vue&type=style&index=0&id=517a1927&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517a1927",
  null
  
)

export default component.exports